import businessType from "./businessSettingsTypes";

const initialState = {
  isLoading: false,
  approving: false,
  searching: false,
  filtering: false,
  updating: false,
  myBusinessSettings: {},
  business: {},
  allBusinesses: {},
  filterNoPage: {},
  search: [],
};

export default function businessSettingsReducer(state = initialState, action) {
  switch (action.type) {
    case businessType.LOADING_BUSINESS_SETTINGS:
      return {
        ...state,
        isLoading: action.payLoad,
      };
    case businessType.FILTERING:
      return {
        ...state,
        filtering: action.payLoad,
      };
    case businessType.FILTER_BUSINESS:
      return {
        ...state,
        allBusinesses: action.payLoad?.data,
      };
    case businessType.FILTER_BUSINESS_NOPAGE:
      return {
        ...state,
        filterNoPage: action.payLoad?.data,
      };
    case businessType.LOADING_SEARCH:
      return {
        ...state,
        searching: action.payLoad,
      };

    case businessType.SEARCH_BUSINESS:
      return {
        ...state,
        search: action.payLoad?.data,
      };

    case businessType.MY_BUSINESS_SETTINGS:
      return {
        ...state,
        myBusinessSettings: action.payLoad?.data,
      };

    case businessType.A_BUSINESS:
      return {
        ...state,
        business: action.payLoad?.data,
      };

    case businessType.UPDATE_BUSINESS_SETTINGS:
      return {
        ...state,
        myBusinessSettings: action.payLoad?.data,
      };

    case businessType.UPDATING_BUSINESS_SETTINGS:
      return {
        ...state,
        updating: action.payLoad,
      };

    case businessType.GET_ALL_BUSINESSES:
      let unapprovedData = {};
      if (action.payLoad?.data === undefined) {
        unapprovedData = {};
      } else {
        unapprovedData = action.payLoad?.data;
      }
      return {
        ...state,
        allBusinesses: unapprovedData,
      };

    default:
      return state;
  }
}
